import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { Loading } from "@/components/atoms/Loading";
import { PushAlarm } from "@/common/types/pushAlarm";
import { AlertText } from "@/components/atoms/AlertText";
import { AlarmList } from "@/components/molecules/AlarmList";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { SwitchButton } from "@/components/atoms/Buttons/SwitchButton";
import { useRecoilValue } from "recoil";
import { GET_PUSH_ALARM } from "@/common/querykeys";
import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "@/common/states/user";

export const SettingAlarmPage = () => {
  /** 📦 State Store */
  const student = useRecoilValue(studentUserState);
  const guardian = useRecoilValue(guardianUserState);
  const loginType = useRecoilValue(loginTypeState);

  /** 🗄️ Cache Control Object */
  const queryClient = useQueryClient();

  /** 📡 API Layer */
  // 특정 사용자의 푸쉬 알림 전체 글 조회
  const { data: pushAlarmData, isPending } = useQuery<PushAlarm>({
    queryKey: [GET_PUSH_ALARM],
    queryFn: async () => {
      return await request<PushAlarm>({
        method: "GET",
        url:
          loginType === "student"
            ? `/push-alarm/${student.id}`
            : `/push-alarm/${guardian.id}`,
      });
    },
  });

  /** 📦 State Store */
  const [alarm, setAlarm] = useState(
    pushAlarmData?.pushAlarmState[0].alarmstatus === "on" ? true : false
  );

  /** 🔄 Side Effect Management */
  useEffect(() => {
    if (pushAlarmData?.pushAlarmState[0].alarmstatus) {
      setAlarm(pushAlarmData?.pushAlarmState[0].alarmstatus === "on");
    }
  }, [pushAlarmData]);

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <>
          {pushAlarmData && pushAlarmData.getPushAlarms.length > 0 ? (
            <MainTemplate
              nav={false}
              subPage={true}
              menuBtn={false}
              buttonLeft={
                <Buttons
                  type="button"
                  size="headerTextIcon"
                  layout="text"
                  color="bright100"
                  icon={<IconArrow />}
                  label="설정"
                  onClick={() => window.history.back()}
                />
              }
              buttonRight={
                <SwitchButton
                  value={alarm}
                  onClick={async () => {
                    const next = !alarm;
                    setAlarm(next);
                    try {
                      await request({
                        method: "POST",
                        url: "/push-alarm/alarm-change",
                        data: {
                          value: next,
                          id:
                            loginType === "student" ? student.id : guardian.id,
                          loginType: loginType,
                        },
                      });
                      queryClient.invalidateQueries({
                        queryKey: [GET_PUSH_ALARM],
                      });
                    } catch (error) {
                      setAlarm(!next);
                      console.error("알람 상태 변경 실패:", error);
                    }
                  }}
                  id={loginType === "student" ? student.id : guardian.id}
                  loginType={loginType}
                />
              }
              pageTitle="알림 목록"
            >
              <>
                <AlarmList data={pushAlarmData.getPushAlarms} />
              </>
            </MainTemplate>
          ) : (
            <MainTemplate
              nav={false}
              subPage={true}
              menuBtn={false}
              buttonLeft={
                <Buttons
                  type="button"
                  size="headerTextIcon"
                  layout="text"
                  color="bright100"
                  icon={<IconArrow />}
                  label="설정"
                  onClick={() => window.history.back()}
                />
              }
              buttonRight={
                <SwitchButton
                  value={alarm}
                  onClick={async () => {
                    const next = !alarm;
                    setAlarm(next);
                    try {
                      await request({
                        method: "POST",
                        url: "/push-alarm/alarm-change",
                        data: {
                          value: next,
                          id:
                            loginType === "student" ? student.id : guardian.id,
                          loginType: loginType,
                        },
                      });
                      queryClient.invalidateQueries({
                        queryKey: [GET_PUSH_ALARM],
                      });
                    } catch (error) {
                      setAlarm(!next);
                      console.error("알람 상태 변경 실패:", error);
                    }
                  }}
                  id={loginType === "student" ? student.id : guardian.id}
                  loginType={loginType}
                />
              }
              pageTitle="알림 목록"
            >
              <>
                <AlertText subText="수신된 알림이 없습니다." />
              </>
            </MainTemplate>
          )}
        </>
      )}
    </>
  );
};
